<template>
  <div class="contact-page" id="app">
    <headerView :seletedindex="seletedindex" />

    <!-- 顶部横幅 -->
    <div
      class="banner"
      :style="{
        backgroundImage:
          'url(' +
          contactUsBanner.imgUrl +
          ')',
      }"
    >
      <!-- <div class="banner-content">
        <h1>{{ contactUsBanner.title }}</h1>
        <p>{{ contactUsBanner.subTitle }}</p>
      </div> -->
    </div>

    <!-- 热招职位部分 -->
    <div class="hot-jobs-section">
      <h2 class="section-title">热招职位</h2>
      <div class="job-categories">
        <button
          v-for="category in jobCategories"
          :key="category.key"
          class="category-btn"
          :class="{ active: selectedCategory === category.key }"
          @click="selectedCategory = category.key"
        >
          {{ category.label }}
        </button>
      </div>

      <!-- 职位列表 -->
      <div class="jobs-list">
        <div v-for="(job, index) in filteredJobs" :key="index" class="job-card">
          <h3 class="job-title">{{ job.title }}</h3>
          <div class="job-location">
            <i class="el-icon-location-outline"></i>
            <span>{{ job.location }}</span>
          </div>
          <div class="job-salary">
            <i class="el-icon-money"></i>
            <span>{{ job.salary }}</span>
          </div>
          <div class="job-requirements">
            {{ job.description }}
          </div>
          <div class="job-footer">
            <button class="view-details-btn" @click="applyJob(job)">
              查看详情
            </button>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="filteredJobs.length === 0" class="empty-state">
        <p>暂无相关职位信息</p>
      </div>
    </div>

    <!-- 联系我们部分 -->
    <div class="contact-section">
      <h2 class="section-title">联系我们</h2>
      <p class="contact-desc">
        如果您对我们的招聘职位感兴趣或者有任何疑问,欢迎通过以下方式联系我们,期待您的加入!
      </p>
      <div class="contact-methods">
        <div class="contact-method">
          <div class="contact-icon">
            <i class="el-icon-message"></i>
          </div>
          <div class="contact-info">
            <div class="contact-label">电子邮件</div>
            <div class="contact-detail">shifeifei@xy3.cn</div>
          </div>
        </div>
        <div class="contact-method">
          <div class="contact-icon">
            <i class="el-icon-phone"></i>
          </div>
          <div class="contact-info">
            <div class="contact-label">招聘热线</div>
            <div class="contact-detail">13485168881</div>
          </div>
        </div>
      </div>
    </div>

    <footerView />
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import {
  homeBanner,
  obtainJobType,
  obtainJobInformation,
} from "@/api/index";

export default {
  name: "ContactUs",
  components: {
    headerView,
    footerView,
    Map,
  },
  data() {
    return {
      seletedindex: 6,
      selectedCategory: "all", // 默认选中全部职位
      jobCategories: [],
      contactUsBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      jobs: [],
    };
  },
  computed: {
    filteredJobs() {
      if (this.selectedCategory === "all") {
        return this.jobs;
      }
      return this.jobs.filter(
        (job) => job.categoryKey === this.selectedCategory
      );
    },
  },
  created() {
    this.$nextTick(() => {
      this.getcontactUsBanner();
      this.getType();
      this.getobtainJobInformation();
    });
  },
  methods: {
    async getType() {
      const typeposition = await obtainJobType(
        "/api/zaoying/recruitmentCategories"
      );
      console.log(typeposition);
      if (typeposition.length > 0) {
        this.jobCategories = [
          { key: "all", label: "全部" },
          ...typeposition.map((item) => {
            return {
              key: item.id,
              label: item.title,
            };
          }),
        ];
      }
    },
    async getobtainJobInformation() {
      const jobInformation = await obtainJobInformation(
        "/api/zaoying/recruitments",
        {
          category_id: "",
          pageNumber: 1,
          pageSize: 10000,
        }
      );
      console.log(jobInformation);
      if (jobInformation && jobInformation.items.length > 0) {
        this.jobs = [
          ...jobInformation.items.map((item) => {
            return {
              id: item.id,
              title: item.zhiweimingcheng,
              category: item.categoryName,
              categoryKey: item.categoryId,
              location: item.gongzuodidian,
              salary: item.xinzi,
              description:item.zhiweijianjie
            };
          }),
        ];
      }
    },
    async getcontactUsBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 24 });
      if (res && res.length > 0) {
        this.contactUsBanner = res[0];
      }
    },
    applyJob(job) {
      // 跳转到职位详情页
      this.$router.push({
        name: "jobDetail",
        params: { id: job.id },
      });
    },
  },
};
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background-color: #fff; /* 改回纯白色背景 */
}

.banner {
  background-size: cover;
  background-position: center;
  height: 25vw; /* 设置为视窗宽度的1/3 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner h1 {
  font-size: 42px; /* 增大标题字体 */
  margin-bottom: 25px;
  font-weight: 500;
}

.banner p {
  font-size: 20px; /* 增大描述文字字体 */
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

.contact-cards {
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  gap: 30px;
}

.contact-card {
  background: white; /* 白色卡片背景 */
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  flex: 1;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.contact-card i {
  font-size: 36px;
  color: #1890ff;
}

.card-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 25px;
  font-weight: 500;
}

.contact-card .info {
  text-align: center;
  width: 100%;
}

.contact-card .info p {
  margin: 12px 0;
  color: #666;
  font-size: 15px;
}

.text-bold {
  font-weight: 500;
}

.primary {
  color: #1890ff;
  font-size: 18px !important;
}

.contact-form {
  background: white;
  width: 100%; /* 设置为视窗宽度 */
  margin-left: calc(-50vw + 50%); /* 负边距技巧使div撑满宽度 */
  margin-right: calc(-50vw + 50%);
  margin-top: 60px;
  margin-bottom: 60px;
  padding: 40px 0; /* 移除左右padding */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 添加内容容器来控制表单内容的宽度 */
.contact-form form {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px; /* 添加内容的左右padding */
}

.contact-form h2,
.form-desc {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px; /* 标题和描述文字也需要左右padding */
}

.contact-form h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 500;
  text-align: center;
}

.form-desc {
  color: #666;
  margin-bottom: 30px;
  text-align: center; /* 描述文字居中 */
}

.form-group {
  margin-bottom: 20px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 15px;
}

.required {
  color: #ff4d4f;
  margin-left: 4px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #bfbfbf;
}

.el-form-item {
  margin: 10px auto;
}

.submit-btn {
  background: #1890ff;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  max-width: 800px; /* 提交按钮最大宽度 */
  margin: 20px auto;
  display: block;
  transition: background 0.3s;
}

.submit-btn:hover {
  background: #40a9ff;
}

.faq-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.faq-section h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
  text-align: center;
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px; /* 增加间距 */
  margin: 0 auto;
}

.faq-item {
  background: white; /* 白色FAQ背景 */
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: none;
}

.faq-item h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: normal;
}

.faq-item p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* 添加响应式布局调整 */
@media (max-width: 1240px) {
  .contact-form,
  .faq-section {
    margin: 60px 20px;
  }
}

@media (max-width: 768px) {
  .contact-form {
    padding: 30px 0; /* 移除左右padding，只保留上下padding */
  }

  .contact-cards {
    flex-direction: column;
    align-items: center;
    margin: 40px 20px;
  }

  .contact-card {
    width: 100%;
    margin: 10px 0;
  }

  .faq-grid {
    grid-template-columns: 1fr;
  }

  .banner {
    height: 50vw; /* 在移动端可以适当调整比例 */
  }
}

.form-group input.message-input {
  height: 100px; /* 设置留言内容输入框的高度 */
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #1890ff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.news_information {
  width: 100%;
}

.news_information_title {
  font-size: 25px;
  padding: 63px 0px 13px 0px;
  text-align: center;
}
.news_information_div {
  width: 50%;
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
}
.news_information_div .el-card__body,
.el-main {
  padding: 0px;
}
.news_information_card {
  margin: 0;
  padding: 0;
  min-width: 20px;
  width: 20%;
  line-height: 2;
  margin: 20px 0px;
  border-radius: 15px;
  text-align: left;
  cursor: pointer;
}

.news_information_card_img {
  width: 100%;
  height: 100%;
}

.news_information_card_p2 {
  font-weight: bold;
  font-size: 19px;
  text-align: center;
  white-space: nowrap;
}

.mapstyle {
  width: 50%;
  margin: 0px auto;
}

/* 子公司一览样式 */
.subsidiary-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.subsidiary-title {
  font-size: 32px;
  font-weight: 500;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

.subsidiary-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.subsidiary-card {
  background: #fff;
  border-radius: 8px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.subsidiary-icon {
  margin-bottom: 20px;
}

.subsidiary-icon img {
  width: 300px;
  border-radius: 10px;
}

.subsidiary-name {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
  line-height: 1.4;
}

.subsidiary-services {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
  min-height: 40px;
}

.subsidiary-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  max-width: max-content;
  margin: 0 auto;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.info-item .iconfont {
  font-size: 16px;
  color: #999;
}

.subsidiary-intro {
  width: 100%;
  margin-top: 25px;
  padding: 0 10px;
}

.subsidiary-intro p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  text-align: left;
  margin: 0;
  max-width: 100%;
  text-indent: 2em;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .subsidiary-cards {
    grid-template-columns: 1fr;
  }

  .subsidiary-title {
    font-size: 28px;
  }
}

/* 热招职位部分样式 */
.hot-jobs-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
  text-align: center;
}

.section-title {
  font-size: 32px;
  font-weight: 500;
  color: #000;
  margin-bottom: 30px;
  text-align: center;
}

.job-categories {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.category-btn {
  padding: 10px 20px;
  border: none;
  background: #fff;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid #e8e8e8;
}

.category-btn:hover {
  background: #f5f5f5;
}

.category-btn.active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

/* 职位列表样式 */
.jobs-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
  margin-top: 40px;
  padding: 0;
}

.job-card {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
}

.job-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.job-title {
  font-size: 22px;
  font-weight: bold;
  color: #000;
  margin: 0 0 15px 0;
  text-align: left;
}

.job-location {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  text-align: left;
}

.job-location i {
  color: #999;
  font-size: 16px;
}

.job-location span {
  font-size: 14px;
  color: #666;
}

.job-salary {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 15px;
  text-align: left;
}

.job-salary i {
  color: #999;
  font-size: 16px;
}

.job-salary span {
  font-size: 14px;
  color: #666;
}

.job-requirements {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: left;
  flex: 1;
}

.job-footer {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.view-details-btn {
  padding: 10px 30px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.view-details-btn:hover {
  background: #40a9ff;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 16px;
}

/* 联系我们部分样式 */
.contact-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto 80px auto;
  padding: 0 20px;
  text-align: center;
}

.contact-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.6;
}

.contact-methods {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
}

.contact-method {
  display: flex;
  align-items: center;
  gap: 15px;
}

.contact-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  font-size: 24px;
}

.contact-icon i {
  font-size: 24px;
  color: #1890ff;
}

.contact-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.contact-label {
  font-size: 16px;
  color: #000;
  margin-bottom: 5px;
  font-weight: 500;
}

.contact-detail {
  font-size: 14px;
  color: #999;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .hot-jobs-section,
  .contact-section {
    margin: 40px auto;
  }

  .job-categories {
    gap: 10px;
  }

  .category-btn {
    padding: 8px 16px;
    font-size: 14px;
  }

  .jobs-list {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .job-card {
    padding: 20px;
  }

  .job-title {
    font-size: 20px;
  }

  .view-details-btn {
    padding: 8px 24px;
    font-size: 13px;
  }

  .contact-methods {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }

  .contact-method {
    flex-direction: column;
    text-align: center;
  }

  .contact-info {
    align-items: center;
  }

  .section-title {
    font-size: 28px;
  }
}
</style>